import api from "../../service/api";
import ConfigureInfo from "@/connect/configureInfo";
import router from "../../router";
export default {
  state: () => ({
    queryPairInfo: {
      lastPrice: "0",
      markPrice: "0",
      openPrice: "0",
      oraclePrice: "0",
      chainId: "dex-btc",
      jsonRpcUrl: "",
      pair: "",
      rpcUrl: "",
      tradeActive: true,
      holdPositionAmount: "",
      pricePrecision: 3,
      state: 0, // 0 已上线，1已下线,2暂停交易，3 等待上架
    },
    queryPairData: [],
  }),
  mutations: {
    SET_QUERY_PAIR_INFO(state, opt) {
      console.log("SET_QUERY_PAIR_INFO", opt);
      if (opt) {
        state.queryPairInfo = opt;

        sessionStorage.setItem("pairInfo", JSON.stringify(opt));
      } else {
        sessionStorage.removeItem("pairInfo");
      }
    },
    SET_QUERY_PAIR_DATA(state, opt) {
      state.queryPairData = opt;
    },
    SET_QUERY_PAIR_LAST_PRICE(state, opt) {
      state.queryPairData[opt.index].lastPrice = opt.newPrice;
    },
    SET_QUERY_PAIR_TRADE_ACTIVE(state, opt) {
      state.queryPairData[opt.index].state = opt.state;
    },
    SET_MARKET(state, opt) {
      opt.forEach((oValue) => {
        try {
          state.queryPairData.forEach((pValue, index) => {
            if (oValue.pair === pValue.pair) {
              if (oValue.markPrice !== undefined) {
                state.queryPairData[index].markPrice = oValue.markPrice;
              }
              if (oValue.oraclePrice !== undefined) {
                state.queryPairData[index].oraclePrice = oValue.oraclePrice;
              }
              if (oValue.openPrice !== undefined) {
                state.queryPairData[index].openPrice = oValue.openPrice;
              }
              if (oValue.dayHighPrice !== undefined) {
                state.queryPairData[index].dayHighPrice = oValue.dayHighPrice;
              }
              if (oValue.dayLowPrice !== undefined) {
                state.queryPairData[index].dayLowPrice = oValue.dayLowPrice;
              }
              if (oValue.dayTrade !== undefined) {
                state.queryPairData[index].dayTrade = oValue.dayTrade;
              }
              if (oValue.dayVolume !== undefined) {
                state.queryPairData[index].dayVolume = oValue.dayVolume;
              }
              if (oValue.holdPositionAmount !== undefined) {
                state.queryPairData[index].holdPositionAmount =
                  oValue.holdPositionAmount;
              }
              throw new Error("SET_MARKET");
            }
          });
        } catch (error) {
          /*eslint no-empty: "error"*/
        }
      });
    },
  },
  actions: {
    async setQueryPairUnsubscribe({ rootState }) {
      await rootState.ws.websocketsend({
        type: "unsubscribe",
        channel: "new_price",
        id: "",
        chainId: ConfigureInfo.Marginx.chainId,
      });
    },
    async getQueryPairData({ commit, dispatch, rootState }) {
      const queryPairData = await api["queryPair"]({});

      rootState.ws.websocketsend({
        type: "subscribe",
        channel: "new_price",
        id: "",
        chainId: ConfigureInfo.Marginx.chainId,
      });

      commit("SET_QUERY_PAIR_DATA", queryPairData);

      dispatch("setPairInfo", queryPairData[0]);
    },
    setPairInfo({ state, commit }, opt) {
      const pair = router.currentRoute.query.pair;
      let pairFind = state.queryPairData.find((v) => v.pair === pair);

      if (!pairFind) {
        const pairInfo = JSON.parse(sessionStorage.getItem("pairInfo") || "{}");
        pairFind = state.queryPairData.find((v) => v.pair === pairInfo.pair);
      }

      commit("SET_QUERY_PAIR_INFO", pairFind || opt);
    },
    setNewPrice({ commit, state, dispatch }, data) {
      data.forEach((sonVal) => {
        try {
          state.queryPairData.forEach((fatherVal, index) => {
            if (sonVal.pair === fatherVal.pair) {
              if (sonVal.newPrice !== undefined) {
                commit("SET_QUERY_PAIR_LAST_PRICE", {
                  newPrice: sonVal.newPrice,
                  index: index,
                });
              }
              if (sonVal.state !== undefined) {
                commit("SET_QUERY_PAIR_TRADE_ACTIVE", {
                  state: sonVal.state,
                  index: index,
                });
              }

              if (sonVal.priceAdjust !== undefined && sonVal.priceAdjust) {
                dispatch("kLine/getInfo");
              }

              throw new Error("setNewPrice");
            }
          });
        } catch (error) {
          /*eslint no-empty: "error"*/
        }
      });
    },
    setMarketPrice({ commit }, data) {
      commit("SET_MARKET", data);
    },
  },
  getters: {
    getQueryPairInfo: (state) => {
      return state.queryPairInfo;
    },
  },
};
